import { FiBriefcase, FiUsers, FiAward, FiGlobe, FiCoffee } from "react-icons/fi";

const CARD_BORDER = "linear-gradient(185.28deg, rgba(102,194,255,0.7) 5.23%, rgba(116,156,255,0.12) 46.68%, rgba(123,135,255,0.45) 69.87%, rgba(132,112,255,0.56) 95.03%)";

const ICON_BORDER = "linear-gradient(185.28deg, rgba(102,194,255,0.35) 5.23%, rgba(116,156,255,0.06) 46.68%, rgba(123,135,255,0.225) 69.87%, rgba(132,112,255,0.28) 95.03%)";

const CARD_BG = "linear-gradient(90deg, rgba(255,255,255,0.0408) 0%, rgba(255,255,255,0.0782) 100%)";

const stats = [
  {
    number: "300+",
    label: "Projects Delivered",
    icon: <FiBriefcase size={18} />,
    iconColor: "#D946EF",
  },
  {
    number: "100+",
    label: "Happy Clients",
    icon: <FiUsers size={18} />,
    iconColor: "#818CF8",
  },
  {
    number: "50+",
    label: "Retained & Referred Clients",
    icon: <FiCoffee size={18} />,
    iconColor: "#C084FC",
  },
  {
    number: "10+",
    label: "Years of Experience",
    icon: <FiAward size={18} />,
    iconColor: "#34D399",
  },
  {
    number: "10+",
    label: "Countries Served",
    icon: <FiGlobe size={18} />,
    iconColor: "#60A5FA",
  },
];

const sectionStyle = {
  padding: "10px 24px",
  display: "flex",
  justifyContent: "center",
};

const wrapperStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "16px",
  justifyContent: "center",
};

function cardWrapperStyle() {
  return {
    width: "250px",
    height: "118px",
    borderRadius: "12px",
    padding: "1px",
    background: CARD_BORDER,
    backdropFilter: "blur(4px)",
    WebkitBackdropFilter: "blur(4px)",
    flexShrink: 0,
  };
}

const cardInnerStyle = {
  width: "100%",
  height: "100%",
  borderRadius: "11px",
  background: "var(--home-clients)",
  backdropFilter: "blur(4px)",
  WebkitBackdropFilter: "blur(4px)",
  display: "flex",
  alignItems: "center",
  gap: "12px",
  paddingLeft: "15px",
  paddingRight: "15px",
  boxSizing: "border-box",
};

function iconBoxStyle(color) {
  return {
    width: "38px",
    height: "42px",
    minWidth: "38px",
    borderRadius: "6px",
    border: "1px solid transparent",
    backgroundImage: `${ICON_BORDER}`,
    backgroundOrigin: "border-box",
    backgroundClip: "padding-box",
    padding: "10px 8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: color,
    boxShadow: `inset 0 0 0 1px rgba(102,194,255,0.25)`,
    boxSizing: "border-box",
    flexShrink: 0,
  };
}

const textBlockStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "4px",
};

const titleStyle = {
  fontFamily: "'Roboto', sans-serif",
  fontWeight: 500,
  fontSize: "48px",
  lineHeight: "36px",
  letterSpacing: "-1px",
  color: "var(--text-primary)",
  margin: 0,
};

const descStyle = {
  fontFamily: "'Roboto', sans-serif",
  fontWeight: 400,
  fontSize: "13.5px",
  lineHeight: "15px",
  letterSpacing: "0px",
  color: "var(--text-secondary)",
  margin: 0,
};

export default function HomeStats() {
  return (
    <>
      <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap" rel="stylesheet" />

      <section style={sectionStyle}>
        <div style={wrapperStyle}>
          {stats.map((item, i) => (
            <div key={i} style={cardWrapperStyle()}>
              <div style={cardInnerStyle}>
                <div style={iconBoxStyle(item.iconColor)}>{item.icon}</div>
                <div style={textBlockStyle}>
                  <h2 style={titleStyle}>{item.number}</h2>
                  <p style={descStyle}>{item.label}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
